// icon:scroll | Unicons https://iconscout.com/unicons | Iconscout
import * as React from "react";

function IconScroll(props) {
  return (
    <svg viewBox="0 0 24 24" fill="#fff" height="3em" width="3em" {...props}>
      <path d="M11.29 9.71a1 1 0 001.42 0l5-5a1 1 0 10-1.42-1.42L12 7.59l-4.29-4.3a1 1 0 00-1.42 1.42zm1.42 4.58a1 1 0 00-1.42 0l-5 5a1 1 0 001.42 1.42l4.29-4.3 4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42z" />
    </svg>
  );
}

export default IconScroll;
